<template>
    <v-container pt-5 fluid style="color:black" class="policeLato">
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl>
            <section>
                <div class="mt-5 paralax-cover-image has-background-dim">
                    <div class="paralax-cover-image-text">
                    <div class="content_home" style="z-index: 1!important;">
                        <h1 style="text-align:left;font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('contact.header_title[0]') }}</span></h1>
                        <h1 style="text-align:left;font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('contact.header_title[1]') }}</span></h1>
                    </div>
                </div>
                </div>
            </section>

            <v-layout row wrap class="column">
                <v-flex xs12 sm12 md12 lg12 pa-2 style="background-color: #f5f6f6;">
                    <div class="justify-content-center column pt-5">
                        <div class="justify-content-center row pt-5">
                            <h1 class="justify-content-center row titre_for_desktop">{{ $t('contact.contactez_nous_title') }}</h1>
                        </div>
                        <div class="justify-content-center row mt-2">
                            <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                        </div>
                    </div>
                </v-flex>
                <!---- ================ WEB ================== -->
                <v-layout style="background-color: #f5f6f6">
                    <v-flex xs8 style="margin-left:7%">
                        <div class="pa-5 text-justify subheading font-weight-blod pl-md-5 pr-md-5">
                            <div class="page">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                        <!-- Formulaire de Contact -->
                                        <div>
                                            <div class="loan-group loan-group-0" style="background-color: #f5f6f6">
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[0]') }}</label>
                                                                <input v-model="nom" :placeholder="$t('contact.formulaire_placeholder[0]')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[1]') }}</label>
                                                                <input v-model="prenom" :placeholder="$t('contact.formulaire_placeholder[1]')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[2]') }}</label>
                                                                <input @keypress="onlyNumber" v-model="telephone" :placeholder="$t('contact.formulaire_placeholder[2]')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[3]') }}</label>
                                                                <input v-model="email" :placeholder="$t('contact.formulaire_placeholder[3]')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-12" v-if="this.sujet !== 'Autre'">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                              <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[4]') }}</label>
                                                              <select v-model="sujet" id="Stepper24" name="Step8" class="field-select" @change="subjectSelectControl">
                                                                <option value="Assurance Auto">{{ $t('contact.value_sujet[0]') }}</option>
                                                                <option value="Assurance Moto">{{ $t('contact.value_sujet[1]') }}</option>
                                                                <option value="Assurance Habitation">{{ $t('contact.value_sujet[2]') }}</option>
                                                                <option value="Assurance Voyage">{{ $t('contact.value_sujet[3]') }}</option>
                                                                <option value="Assurance Sante">{{ $t('contact.value_sujet[4]') }}</option>
                                                                <option value="Assurance Vie">{{ $t('contact.value_sujet[5]') }}</option>
                                                                <option value="Assurance Pro">{{ $t('contact.value_sujet[6]') }}</option>
                                                                <option value="Autre">{{ $t('contact.value_sujet[7]') }}</option>
                                                              </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6" v-if="this.sujet == 'Autre'">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                          <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[4]') }}</label>
                                                          <select v-model="sujet" id="Stepper24" name="Step8" class="field-select" @change="subjectSelectControl">
                                                            <option value="Assurance Auto">{{ $t('contact.value_sujet[0]') }}</option>
                                                            <option value="Assurance Moto">{{ $t('contact.value_sujet[1]') }}</option>
                                                            <option value="Assurance Habitation">{{ $t('contact.value_sujet[2]') }}</option>
                                                            <option value="Assurance Voyage">{{ $t('contact.value_sujet[3]') }}</option>
                                                            <option value="Assurance Sante">{{ $t('contact.value_sujet[4]') }}</option>
                                                            <option value="Assurance Vie">{{ $t('contact.value_sujet[5]') }}</option>
                                                            <option value="Assurance Pro">{{ $t('contact.value_sujet[6]') }}</option>
                                                            <option value="Autre">{{ $t('contact.value_sujet[7]') }}</option>
                                                          </select>
                                                        </div>
                                                      </div>

                                                        <div class="col-sm-6" v-if="this.sujet == 'Autre'">
                                                          <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[5]') }}</label>
                                                            <input v-model="autre_sujet" :placeholder="$t('contact.formulaire_placeholder[4]')" id="Stepper28" name="Step8" class="field-input">
                                                          </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[6]') }}</label>
                                                                <textarea rows="4" cols="50" :placeholder="$t('contact.formulaire_placeholder[5]')" v-model="message" id="Stepper28" name="Step8" class="field-input" style="height:150px"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button type="button" @click="sending_message" class="wizard-btn">
                                            {{ $t('contact.bouton_envoye') }}
                                        </button>
                                    </div>
                                    <!---->
                                </div>
                            </div>
                        </div>
                    </v-flex>

                    <v-flex xs4 style="margin-right:8%">
                        <div class="justify-content-center column" style="margin-top:5%">
                            <div class="justify-content-center column">
                                <img src="../assets/img/Assurance.png" alt="kiray mascote" width="380">
                            </div>
                            <div class="justify-content-center row ml-3">
                                <h2 class="field-title font-weight-bold policeLato text-center" style="font-size:15px">{{ $t('contact.texte_cote_message[0]') }} <br> {{ $t('contact.texte_cote_message[1]') }} <br> 
                                    <a href="tel:+221761416464"><span class="font-weight-bold" style="color:#ffa409;font-size:20px">+221 76 141 64 64</span></a>
                                    <!-- <span class="font-weight-bold" style="color:#ffa409;font-size:20px">+221 76 141 64 64</span>--><br>  
                                    <!-- <span class="font-weight-bold" style="color:#ffa409;font-size:20px">+221 76 200 64 64</span><br> -->
                                    <a href="tel:+221762006464"><span class="font-weight-bold" style="color:#ffa409;font-size:20px">+221 76 200 64 64</span></a><br>
                                    <a href="tel:+221768006464"><span class="font-weight-bold" style="color:#ffa409;font-size:20px">+221 76 800 64 64</span></a></h2>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <!--PARITE NEWSLETTER-->
                        <div style="background: rgba(153,153,153,0.39);height: 120px" class="mb-5">
                            <div class="row" style="margin-left: 10.5%">
                                <div class="mt-5 justify-content-center row">
                                    <h1 class="justify-content-center" style="color: #001b19;font-size: 25px;font-weight: bold;margin-top: 6%;text-align: center">{{ $t('home_page.newsletter_title') }}</h1>
                                    <a href="https://www.221assurances.com" target="_blank">
                <img class="mt-1 ml-4" src="../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                </a>
                                </div>

                                <div class="mt-5 justify-content-center row" style="width: 50%;margin-left: -3%">
                                    <input v-model="UserEmail" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
                                </div>
                                <div class="mt-5 justify-content-center row" style="margin-left: -5%">
                                    <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                                        <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <!--PARITE PAIEMENT-->
                        <div style="background: #ffffff;height: 50px;">
                            <div>
                                <div class="justify-content-center row" style="float: left;margin-left: 8%">
                                    <div class="trigger ml-3" style="z-index: 1;">
                    <span>
                                                  <img class="mr-3" loading="lazy" src="../assets/img/writing.png" width="25px"  alt="writing quotes">

                      <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                      {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                                   class="ml-4 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24">
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
                      <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                                        src="../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                              src="../assets/img/icones/menu/house_quote.png"
                                                              :alt="$t('home_page.bouton_devis[2]')"/></i>
                        {{ $t('home_page.bouton_devis[2]') }}</a></li>
                      <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                                          src="../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                      <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                                         src="../assets/img/icones/menu/health_quote.png"
                                                         :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                          $t('home_page.bouton_devis[4]')
                        }}</a></li>
                      <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                                       src="../assets/img/icones/menu/life_quote.png"
                                                       :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                          $t('home_page.bouton_devis[5]')
                        }}</a></li>
                      <li><a href="/plus"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/add_quote.png"
                                                  :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                          $t('home_page.bouton_devis[6]')
                        }}</a></li>
                      <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
                        <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                      <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                                       src="../assets/img/icones/menu/mrp_quote.png"
                                                       alt="devis_mrp"/></i> MRP</a></li>
                      <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                                       src="../assets/img/icones/menu/trc_quote.png"
                                                       alt="devis_trc"/></i>TRC</a></li>
                                                       <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
                    </ul>
                  </div>

                  <div class="trigger-simulation ml-4" style="z-index: 1;">
                    <span>
                                                  <img class="mr-3" loading="lazy" src="../assets/img/rocket.png" width="25px"  alt="writing quotes">

                      <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                      {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                                   class="ml-4 fas fa-chevron-down"></i></span>
                    <ul class="devis elevation-24">
                      <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                                        src="../assets/img/icones/menu/cars_quote.png"
                                                        :alt="$t('home_page.bouton_devis[1]')"/></i>
                        {{ $t('home_page.bouton_devis[1]') }}</a></li>
                      <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                          src="../assets/img/icones/menu/travel_quote.png"
                                                          :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                          $t('home_page.bouton_devis[3]')
                        }}</a></li>
                    </ul>
                  </div>
                                </div>

                                <div class="justify-content-center row" style="float: right;margin-right: 10%;margin-top: 10px">
                                    <div class="justify-content-center row border-radius logo-paiement">
                                        <img width="60px" height="30px" alt="orange-money-logo" src="../assets/img/logoPaiement/orange-money.png"/>
                                        <img width="60" height="30" alt="free-money-logo" src="../assets/img/logoPaiement/freemoney.png"/>
                                        <img class="pt-1" width="60" height="25" alt="visa-logo" src="../assets/img/logoPaiement/visa.png"/>
                                        <img class="ml-2" width="60" height="30" alt="master-card-logo" src="../assets/img/logoPaiement/master-card.png"/>
                                        <img class="ml-2" width="30" height="30" alt="wave-logo" src="../assets/img/logoPaiement/wave.png"/>
                                        <img class="ml-3" width="30" height="30" alt="kpay-logo" src="../assets/img/logoPaiement/kpay_logo.webp"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-layout>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs>
            <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
            <section>
                <div class="paralax-cover-image_mobile has-background-dim_mobile">
                    <p class="paralax-cover-image-text_mobile">
                    <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                        <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('contact.header_title[0]') }}</span></h1>
                        <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('contact.header_title[1]') }}</span></h1>
                    </div>
                    </p>
                </div>
            </section>
            <div class="justify-content-center row" style="background-color: #f5f6f6">
                <div class="justify-content-center column pt-5">
                    <div class="justify-content-center row">
                        <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('contact.contactez_nous_title') }}</h1>
                    </div>
                    <div class="justify-content-center row">
                        <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                    </div>
                </div>
            </div>
            <!--Notre histoire-->
            <v-layout style="background-color: #f5f6f6;">
                <!---- ================ MOBILE ================== -->
                <div class="pl-3 pr-3 pt-3 row">
                    <div class="col-sm-11 pa-4 text-justify subheading font-weight-regular">
                        <div class="page">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8" class="wizard-tab-container">
                                        <!-- Formulaire de Contact -->
                                        <div>
                                            <div class="loan-group loan-group-0" style="background-color: #f5f6f6">
                                                <div class="fields">
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[0]') }}</label>
                                                                <input v-model="nom" :placeholder="$t('contact.formulaire_placeholder[0]')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[1]') }}</label>
                                                                <input v-model="prenom" :placeholder="$t('contact.formulaire_placeholder[1]')" id="Stepper28" name="Step8" class="field-input">
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-6">
                                                          <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[2]') }}</label>
                                                            <input @keypress="onlyNumber" v-model="telephone" :placeholder="$t('contact.formulaire_placeholder[2]')" id="Stepper28" name="Step8" class="field-input">
                                                          </div>
                                                        </div>

                                                        <div class="col-sm-6">
                                                          <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[3]') }}</label>
                                                            <input v-model="email" :placeholder="$t('contact.formulaire_placeholder[3]')" id="Stepper28" name="Step8" class="field-input">
                                                          </div>
                                                        </div>

                                                        <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                          <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[4]') }}</label>
                                                          <select v-model="sujet" id="Stepper24" name="Step8" class="field-select" @change="subjectSelectControl">
                                                            <option value="Assurance Auto">{{ $t('contact.value_sujet[0]') }}o</option>
                                                            <option value="Assurance Moto">{{ $t('contact.value_sujet[1]') }}</option>
                                                            <option value="Assurance Habitation">{{ $t('contact.value_sujet[2]') }}</option>
                                                            <option value="Assurance Voyage">{{ $t('contact.value_sujet[3]') }}</option>
                                                            <option value="Assurance Sante">{{ $t('contact.value_sujet[4]') }}</option>
                                                            <option value="Assurance Vie">{{ $t('contact.value_sujet[5]') }}</option>
                                                            <option value="Assurance Pro">{{ $t('contact.value_sujet[6]') }}</option>
                                                            <option value="Autre">{{ $t('contact.value_sujet[7]') }}</option>
                                                          </select>
                                                        </div>
                                                      </div>

                                                        <div class="col-sm-6" v-if="this.sujet == 'Autre'">
                                                          <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[5]') }}</label>
                                                            <input v-model="autre_sujet" :placeholder="$t('contact.formulaire_placeholder[4]')" id="Stepper28" name="Step8" class="field-input">
                                                          </div>
                                                        </div>

                                                        <div class="col-sm-6">
                                                          <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="Stepper28" class="field-label">{{ $t('contact.formulaire_label[6]') }}</label>
                                                            <textarea rows="4" cols="50" :placeholder="$t('contact.formulaire_placeholder[5]')" v-model="message" id="Stepper28" name="Step8" class="field-input" style="height:150px"></textarea>
                                                          </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button type="button" @click="sending_message" class="wizard-btn">
                                            {{ $t('contact.bouton_envoye') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </v-layout>

            <!--PARITE NEWSLETTER-->
            <v-layout>
                <div style="background: rgba(153,153,153,0.39);height:auto;width: 100%">
                    <div class="justify-content-center column">
                        <div class="pt-5 justify-content-center row">
                            <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('home_page.newsletter_title') }}</h1>
                        </div>

                        <div class="justify-content-center row">
              <a href="https://www.221assurances.com" target="_blank">
                <img class="mt-3 mb-4" src="../assets/img/logos_sn_221.png" alt="logos_sn_221" style="width: 50px;cursor: pointer;">
                </a>
            </div>

                        <div class="mt-2 justify-content-center row">
                            <input v-model="UserEmail" type="email" name="email" id="email_input" :placeholder="$t('home_page.newsletter_input_placeholder')">
                        </div>

                        <div class="justify-content-center row pb-5">
                            <button style="height: 50px!important" flat class="newsletter ml-2" @click="suscribeNewsletter221()">
                                <span class="newsletter">{{ $t('home_page.newsletter_bouton') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </v-layout>

            <!--PARITE PAIEMENT-->
            <v-layout>
                <div style="background: #ffffff;height:auto;width: 100%">
                    <div class="column pb-5 pt-5" style="z-index: 1!important;">
                        <div class="justify-content-center row">
                            <div class="trigger" style="z-index: 2!important;position: relative;">
                                <span>
                                                              <img class="mr-3" loading="lazy" src="../assets/img/writing.png" width="25px"  alt="writing quotes">

                                <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                                {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                                            class="ml-4 fas fa-chevron-down"></i></span>
                                <ul class="devis elevation-24">
                                <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
                                <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                                                    src="../assets/img/icones/menu/cars_quote.png"
                                                                    :alt="$t('home_page.bouton_devis[1]')"/></i>
                                    {{ $t('home_page.bouton_devis[1]') }}</a></li>
                                <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                                        src="../assets/img/icones/menu/house_quote.png"
                                                                        :alt="$t('home_page.bouton_devis[2]')"/></i>
                                    {{ $t('home_page.bouton_devis[2]') }}</a></li>
                                <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                                                    src="../assets/img/icones/menu/travel_quote.png"
                                                                    :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                                    $t('home_page.bouton_devis[3]')
                                    }}</a></li>
                                <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                                                    src="../assets/img/icones/menu/health_quote.png"
                                                                    :alt="$t('home_page.bouton_devis[4]')"/></i>{{
                                    $t('home_page.bouton_devis[4]')
                                    }}</a></li>
                                <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                                                src="../assets/img/icones/menu/life_quote.png"
                                                                :alt="$t('home_page.bouton_devis[5]')"/></i>{{
                                    $t('home_page.bouton_devis[5]')
                                    }}</a></li>
                                <li><a href="/plus"><i><img class="mr-2" width="35" src="../assets/img/icones/menu/add_quote.png"
                                                            :alt="$t('home_page.bouton_devis[6]')"/></i>{{
                                    $t('home_page.bouton_devis[6]')
                                    }}</a></li>
                                <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
                                  <li><a href="/flotte/entreprise"><i><img class="mr-2" width="30" src="../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
                                <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                                                src="../assets/img/icones/menu/mrp_quote.png"
                                                                alt="devis_mrp"/></i> MRP</a></li>
                                <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                                                src="../assets/img/icones/menu/trc_quote.png"
                                                                alt="devis_trc"/></i>TRC</a></li>
                                                                <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
                                </ul>
                            </div>

                 
                                </div>
                            <div class="justify-content-center row">
                                <div class="trigger-simulation mt-4" style="z-index: 1;position: relative;">
                        <span>
                                                      <img class="mr-3" loading="lazy" src="../assets/img/rocket.png" width="25px"  alt="writing quotes">

                        <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
                        {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                                    class="ml-4 fas fa-chevron-down"></i></span>
                        <ul class="devis elevation-24">
                        <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/cars_quote.png"
                                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
                            {{ $t('home_page.bouton_devis[1]') }}</a></li>
                        <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                            src="../assets/img/icones/menu/travel_quote.png"
                                                            :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                            $t('home_page.bouton_devis[3]')
                            }}</a></li>
                        </ul>
                    </div>
                            </div>

                        <div class="justify-content-center row mt-3" style="z-index: 1!important;">
                            <div class="justify-content-center row border-radius logo-paiement mt-2">
                                <img width="50" height="30" alt="orange-money-logo" src="../assets/img/logoPaiement/orange-money.png"/>
                                <img width="60" height="30" alt="free-money-logo" src="../assets/img/logoPaiement/freemoney.png"/>
                                <img class="pt-1" width="60" height="25" alt="visa-logo" src="../assets/img/logoPaiement/visa.png"/>
                              <img class="ml-1" width="60" height="30" alt="master-card-logo" src="../assets/img/logoPaiement/master-card.png"/>
                              <img class="ml-2" width="30" height="30" alt="wave-logo" src="../assets/img/logoPaiement/wave.png"/>
                              <img class="ml-3" width="30" height="30" alt="kpay-logo" src="../assets/img/logoPaiement/kpay_logo.webp"/>
                            </div>
                        </div>
                    </div>
                </div>
            </v-layout>
        </div>
    </v-container>
</template>

<script>
    import store from "../store/store";
    import simplebar from 'simplebar-vue';
    import 'simplebar/dist/simplebar.min.css';
    import Api from '../services/Api';
    import ApiBrevo from "../services/ApiBrevo";
    import PushInDataLayer from '../services/TagManager'

    export default {
        name: 'Home',
        component: {
            Menu: () => import( /* webpackPrefetch: true */ '../components/Menu'),
            simplebar,
        },
        data: () => ({
            tester:"okay",
            UserEmail: null,
            title: 'Assuraf',
            description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
            expand: true,
            maketpopup: false, // Pour checker et afficher le popup marketing si configuré
            objetMarketingPopup: null, // Pour stocker les config du popu Marketing à afficher
            To_check_MaketPopup_State: null,
            dialog: false,
            dialog2: false,
            DevisCountTemp: 0,
            notifications: false,
            overlay: false,
            listTestimo: [],
            nom: '',
            prenom: '',
            CountDevis: null,
            Countpartners: null,
            CountpartnersTemp: 0,
            followers_count: null,
            sujet: '',
            autre_sujet :  '',
            telephone: null,
            ToastTabSucess: { // Customized options for success toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 7000,
                fitToScreen: true,
                type: 'success',
                className: 'custom-success-class'
            },
            ToastTabError: { // Customized options for error toast
                theme: "toasted-primary",
                position: "top-center",
                duration: 7000,
                fitToScreen: true,
                type: 'error'
            },
            email: '',
            emailRules: [
                v => !!v || 'Votre adresse mail est requise.',
                v => /.+@.+/.test(v) || 'L\'adresse mail doit être valide.'
            ],
            message: '',
            CountUpOptions: {
                duration: 4, // animation duration in seconds (2)
                useGrouping: true, // example: 1,000 vs 1000 (true)
                useEasing: true, // ease animation (true)
                separator: (''), // grouping separator (',')
                decimal: ('') // decimal ('')
            }

        }),
        watch: {

            /* Dès que la fenetre s'ouvre, la video se lance automatiquement */
            dialog() {
                let videoFr = this.$refs.theVideo;
                if (this.dialog == true) {
                    videoFr.play()
                } else {
                    videoFr.pause()
                }
            },
            overlay(val) {
                val & setTimeout(() => {
                    this.overlay = false
                }, 3000)
            }
        },
        created() {

            this.fetchEventsList();
            this.timer = setInterval(this.fetchEventsList, 0.01)
        },

        methods: {
                subjectSelectControl(){
                  if (this.sujet == 'Autre') {
                    this.autre_sujet = this.autre_sujet
                  }else {
                    this.autre_sujet = null
                  }
                },
                suscribeNewsletter221 () {
                    if(this.UserEmail) {
                    let newAbonne221 = {
                        listIds: [23],
                        email: this.UserEmail,
                        updateEnabled: false
                    }

                    ApiBrevo().post('contacts', newAbonne221)
                        .then(result => {
                        console.log("result===== ", result)

                        if (result.status === 201) {
                            this.$toasted.show("Merci de votre inscription à notre newsletter 221 !", this.ToastTabSucess);
                            this.UserEmail = ''
                        }
                        }).catch((err) => {
                        console.log("err==== ", err)
                        this.$toasted.show("Le mail saisit est déja inscrit dans notre newsletter", this.ToastTabError);
                        }); 
                    } else {
                    this.$toasted.show("Un email valide est obligatoire pour souscrire à notre newsletter 221", this.ToastTabError);
                    }        
                    },

                abonnementnewsletter() {
                if (this.UserEmail) {
                    if (store.state.isUserLoggedIn) {
                        let newAbonne = {
                            user: this.$store.state.user._id,
                            etat: 'enabled',
                            FNAME: this.$store.state.user.prenom,
                            LNAME: this.$store.state.user.nom,
                            PHONE: this.$store.state.user.telephone_port,
                            email: this.UserEmail,
                            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
                        };

                        Api().post('testimonial/mailchimp/newsletter', newAbonne)
                            .then(res => {
                                if (res.data.ret.statusCode == 200) {
                                    Api().post('newsletter/add', newAbonne)
                                        .then(resp => {
                                            if (resp.data.msg)
                                            {
                                                const GtmVal = {
                                                    event:'newsletter_subscription'
                                                }
                                                PushInDataLayer(GtmVal)
                                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                                this.UserEmail = ''
                                            }
                                        })
                                }
                            })
                            .catch(e => {
                                this.$toasted.show('Votre demande de souscription à la newsletter a échoué ', this.ToastTabError)
                            })

                    } else {

                        let newAbonne = {
                            user: "",
                            etat: 'enabled',
                            FNAME: "",
                            LNAME: "",
                            PHONE: "",
                            email: this.UserEmail,
                            dateAbone: dayjs(new Date()).format('YYYY-MM-DD')
                        };

                        Api().post('testimonial/mailchimp/newsletter', newAbonne)
                            .then(res => {
                                if (res.data.ret.statusCode == 200) {
                                    Api().post('newsletter/add', newAbonne)
                                        .then(resp => {
                                            if (resp.data.msg)
                                            {
                                                const GtmVal = {
                                                    event:'newsletter_subscription'
                                                }
                                                PushInDataLayer(GtmVal)
                                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                                this.UserEmail = ''
                                            }
                                        })
                                }

                            }).catch(e => {
                            this.$toasted.show('Votre demande de souscription à la newsletter a échoué', this.ToastTabError)
                        })
                    }

                } else {
                    this.$toasted.show('Veuillez renseigner votre adresse email ', this.ToastTabError)
                }
            },
            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },

            fetchEventsList() {

                if (this.DevisCountTemp >= 10000) {
                    if (this.DevisCountTemp < this.CountDevis) {
                        this.DevisCountTemp = this.DevisCountTemp + 100
                    }
                    if (this.CountpartnersTemp < this.Countpartners) {
                        this.CountpartnersTemp = this.CountpartnersTemp + 1
                    }
                } else {
                    if (this.DevisCountTemp < this.CountDevis) {
                        this.DevisCountTemp = this.DevisCountTemp + 10
                    }
                    if (this.CountpartnersTemp < this.Countpartners) {
                        this.CountpartnersTemp = this.CountpartnersTemp + 1
                    }
                }

            },

            onScroll(e) {
                this.offsetTop = e.target.scrollTop
            },
            /* Retourne true ou false si nous sommes sur un mobile */
            isMobile: function () {
                if (screen.width <= 425) {
                    return true
                } else {
                    return false
                }
            },

            /* Retourne true ou false si nous sommes sur un PC */
            isDesktop: function () {
                if (screen.width > 768) {
                    return true
                } else {
                    return false
                }
            },
            validEmail(email) {
              const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return re.test(email);
            },

            //Send Message to contact@assuraf.com since the web home page
            sending_message() {
                if (this.nom && this.prenom) {
                    if (this.telephone) {
                        if (this.email && this.validEmail(this.email))
                            if (this.sujet) {
                                if(this.message){
                                  if(this.sujet == 'autre'){
                                    if(this.autre_sujet){
                                      const UserMessage = {
                                        sender_name: this.nom,
                                        sender_prenom: this.prenom,
                                        telephone: this.telephone,
                                        sender_email: this.email,
                                        sujet: this.autre_sujet,
                                        message: this.message

                                      };
                                      Api().post('message/transfert', UserMessage)
                                          .then(response => {
                                            if (response.data.info == 'ok')
                                            {
                                              const GtmVal = {
                                                entry_point:this.$contactUsEntryPoint.entry_point,
                                                event:'contact'
                                              }
                                              PushInDataLayer(GtmVal)

                                              this.$toasted.show('Message transmis. Nous vous répondons très bientôt', this.ToastTabSucess);
                                              this.nom = '';
                                              this.prenom = '';
                                              this.telephone = '';
                                              this.email = '';
                                              this.sujet = '';
                                              this.message = ''
                                            } else {
                                              this.$toasted.show('L\'envoi du message a échoué veuillez réessayer', this.ToastTabError)
                                            }

                                          })
                                    }else {
                                      this.$toasted.show('Veuillez saisir le sujet', this.ToastTabError)
                                    }
                                  }else {
                                    const UserMessage = {
                                      sender_name: this.nom,
                                      sender_prenom: this.prenom,
                                      telephone: this.telephone,
                                      sender_email: this.email,
                                      sujet: this.sujet,
                                      message: this.message

                                    };
                                    Api().post('message/transfert', UserMessage)
                                        .then(response => {
                                          if (response.data.info == 'ok')
                                          {
                                            const GtmVal = {
                                              entry_point:this.$contactUsEntryPoint.entry_point,
                                              event:'contact'
                                            }
                                            PushInDataLayer(GtmVal)

                                            this.$toasted.show('Message transmis. Nous vous répondons très bientôt', this.ToastTabSucess);
                                            this.nom = '';
                                            this.prenom = '';
                                            this.telephone = '';
                                            this.email = '';
                                            this.sujet = '';
                                            this.message = ''
                                          } else {
                                            this.$toasted.show('L\'envoi du message a échoué veuillez réessayer', this.ToastTabError)
                                          }

                                        })
                                  }
                                }else {
                                  this.$toasted.show('Message est obligatoire', this.ToastTabError)
                                }
                            } else {
                                this.$toasted.show('Votre sujet est obligatoire', this.ToastTabError)
                            }
                        else {
                            this.$toasted.show('Votre email doit être valide et obligatoire', this.ToastTabError)
                        }
                    } else {
                        this.$toasted.show('Votre numéro de téléphone est obligatoire ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Nom et Prenom sont obligatoires ', this.ToastTabError)
                }
            },

            ShowMarketPopup() {
                let uripage = this.$route.path;
                Api().post('popup/getpopup', {
                    pagetoshowon: uripage
                })
                    .then(resp => {
                        if (resp.data.popup.length > 0) {
                            if (!this.To_check_MaketPopup_State) {
                                this.maketpopup = true;
                                this.objetMarketingPopup = resp.data.popup
                            }
                        }
                    })
            },
            /*=========On check l'etat des cookies au chargement du composant========*/
            /*======pour savoir si le user a deja cliked sur le popup de marketing===*/
            getCookie() {

              const match = document.cookie.match(new RegExp('(^| )popup_marketing_checked_Home=([^;]+)'));

              if (typeof match == 'object' && match != null) {
                    this.To_check_MaketPopup_State = match
                } else {
                    this.To_check_MaketPopup_State = false
                }

            },

        },
        mounted() {
            window.scrollTo(0, 0);
            this.ShowMarketPopup();
            this.getCookie()
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/less/config";

     ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 15px;
    }
    .underline_bar{
        height:4px;
        width: 150px;
        background:#ffa409;
    }
    .underline_bar_for_number{
        height:4px;
        width: 150px;
        background:#fff;
    }
    .titre_for_desktop{
        color: #2b2b2b;
        font-size: 25px;
        font-weight: bold;
        text-align: center;
    }

    .v-tabs__item--active{
        color: #ffa409;
    }
    .mamadou{
        width: 145px;
        height: 600px;
    }
    .article{
        padding: 1%;
        text-align: justify;
        font-size: 16px;
        line-height: 30px;
        font-family: "Myriad Pro Regular" !important;
    }
    .img-box{
        width: 10%;
        height: 15%;
    }
    .text-sm-left{
        font-family: "Open-Sans" !important;
        font-size: 16px;
        padding: 2%;
        width: 498px;
    }
    .text-xs-right{
        font-family: "Open-Sans" !important;
        padding: 2%;
        padding-top: -1000px;
        margin-left: 700px;
        font-size: 16px;
        width: 498px;
    }
    /*notre equipe*/
    h2 {
        color: #333;
        text-align: center;
        text-transform: uppercase;
        font-family: "Open-Sans", sans-serif;
        font-weight: bold;
        position: relative;
        margin: 30px 0 60px;
    }
    .valeur .description{
        font-size: 14px;
        color: #FFFFFF;
        line-height: 26px;
        text-indent: 30px;
        position: relative;
        margin-top: -29px;
        margin-left: 450px;
    }
    .primary--text{
        font-family: Georgia;
        font-weight: bold;
        color: #000000;
        font-size: 20px;
    .v-tabs__item .v-tabs__item--active{
        color : black;
    }
    }
    .col-center {
        margin: 0 auto;
        float: none !important;
    }
    .carousel {
        margin: 50px auto;
        padding: 0 70px;
    }
    .carousel .item {
        color: #999;
        font-size: 14px;
        text-align: center;
        overflow: hidden;
    }
    .carousel .item .img-box {
        width: 175px;
        height: 175px;
        margin: 0 auto;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 50%;
    }
    .carousel .img-box img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
    }
    .carousel .testimonial {
        padding: 30px 0 10px;
    }
    .carousel .overview {
        font-style: italic;
    }
    .carousel .overview b {
        text-transform: uppercase;
        color: #7AA641;
    }
    .carousel .carousel-control {
        width: 40px;
        height: 40px;
        margin-top: -20px;
        top: 50%;
        background: none;
    }
    .carousel-control i {
        font-size: 68px;
        line-height: 42px;
        position: absolute;
        display: inline-block;
        color: rgba(0, 0, 0, 0.8);
        text-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;
    }
    .carousel .carousel-indicators {
        bottom: -40px;
    }
    .carousel-indicators li, .carousel-indicators li.active {
        width: 10px;
        height: 10px;
        margin: 1px 3px;
        border-radius: 50%;
    }
    .carousel-indicators li {
        background: #999;
        border-color: transparent;
        box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
    }
    .carousel-indicators li.active {
        background: #555;
        box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
    }
    .border-radius{
        border-radius: 10px
    }
    .georgia{
        font-family: Georgia!important;
    }

/* =================== CSS TEAM ASSURAF AVEC CLICK POUR AGRANDIR PHOTO =================== */
/* =================== CSS TEAM ASSURAF AVEC CLICK POUR AGRANDIR PHOTO =================== */
/* =================== CSS TEAM ASSURAF AVEC CLICK POUR AGRANDIR PHOTO =================== */
a {
	color: #fff;
	text-decoration: none;
}
.animation {
	-webkit-transition: .5s ease-in-out;
	-moz-transition: .5s ease-in-out;
	-ms-transition: .5s ease-in-out;
	-o-transition: .5s ease-in-out;
	transition: .5s ease-in-out;
}
.lightboxClose {
	display: block;
	position: absolute;
	width: 100%;
	height: 100%;
}

/* ========== iframe Desktop===========*/
/* ========== iframe Desktop===========*/
/* ========== iframe Desktop===========*/
a.thumbnail img {
	padding: 5px;
	border: 6px solid white;
    border-radius: 10%;
    width: 70%;
    height: 180px;
    display: inline-block
}
.lightbox {
	display: block;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, .5);
	visibility: hidden;
	opacity: 0;
}
.lightbox img, .lightbox iframe {
    margin: auto;
    padding:5px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	max-width: 50%;
	max-height: 70%;
	border: 6px solid white;
    box-sizing: border-box;
}
.lightbox:target {
	visibility: visible;
	opacity: 1;
}
.lightbox:target img, .lightbox:target iframe {
	max-width: 40%;
	max-height: auto;
}
/* ============================== Fin iframe Desktop ==============================*/

/* ========== iframe Mobile===========*/
/* ========== iframe Mobile===========*/
/* ========== iframe Mobile===========*/
a.thumbnail-mobile img {
	padding: 5px;
	border: 6px solid white;
    border-radius: 10%;
    width: 90%;
    height: 180px;
    display: inline-block
}
.lightbox-mobile {
	display: block;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, .5);
	visibility: hidden;
	opacity: 0;
}
.lightbox-mobile img, .lightbox-mobile iframe {
    margin: auto;
    padding:5px;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	max-width: 50%;
	max-height: 50%;
	border: 6px solid white;
    box-sizing: border-box;
}

.lightbox-mobile:target {
	visibility: visible;
	opacity: 1;
}
.lightbox-mobile:target img, .lightbox-mobile:target iframe {
	max-width: 95%;
    max-height: auto;
}
/* ================================ Fin iframe Mobile ===============================*/
    .titlePolice {
        font-family: Merriweather, Georgia, serif;
        font-weight: 300;
        //color: rgb(74, 74, 74);
    }

    .policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }

















    .expansion.expand-list{
        margin: 0;
        padding: 0;
    }
    .expansion.expand-list > li{
        list-style-type: none;
        padding: 15px 0;
        background-color: #fff;
        border-radius: 10px;
        position: relative;
        margin-top: 10%;
        /*         max-width: 80%; */
    }
    .expansion label[class^="tab"]:hover{
        cursor: pointer;
    }
    .expansion input{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    .expansion input[class^="tab"]{
        width: 100%;
        height: 40px;
        position: absolute;
        left: 0;
        top: 0;
    }
    .expansion input[class^="tab"]:hover{
        cursor: pointer;
    }
    .expansion label[class^="tab"]{
        font-weight: bold;
        font-size: 17px;
        margin-left: 3%;
    }
    .expansion .content{
        height: auto;
        max-height: 0;
        max-width: 400px;
        margin-left: 3%;
        font-weight: bold;
        /*        background: yellow;*/
        overflow: hidden;
        transform: translateY(20px);
        transition: all 180ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="100"] input[class^="tab"]:checked ~ .content{
        max-height: 100px;
        transition: all 150ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="200"] input[class^="tab"]:checked ~ .content{
        max-height: 200px;
        transition: all 200ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="300"] input[class^="tab"]:checked ~ .content{
        max-height: 300px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="400"] input[class^="tab"]:checked ~ .content{
        max-height: 400px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="500"] input[class^="tab"]:checked ~ .content{
        max-height: 500px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="600"] input[class^="tab"]:checked ~ .content{
        max-height: 600px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="700"] input[class^="tab"]:checked ~ .content{
        max-height: 700px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="800"] input[class^="tab"]:checked ~ .content{
        max-height: 800px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="900"] input[class^="tab"]:checked ~ .content{
        max-height: 900px;
        transition: all 300ms ease-in-out 0ms;
    }
    .expansion li[data-md-content="1000"] input[class^="tab"]:checked ~ .content{
        max-height: 1000px;
        transition: all 350ms ease-in-out 0ms;
    }
    .expansion li[data-md-content=""] input[class^="tab"]:checked ~ .content{
        max-height: 1000px;
        transition: all 250ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .content{
        margin-bottom: 20px;
    }

    .expansion .open-close-icon{
        display: inline-block;
        position: absolute;
        right: 20px;
        transform: translatey(2px);
    }
    .expansion .open-close-icon i{
        position: absolute;
        left: 0;
    }
    .expansion .open-close-icon .fa-chevron-up{
        transform:rotate(-180deg);
        transition: transform 150ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-up{
        opacity: 1;
        transform: rotate(0deg);
        transition: transform 150ms ease-in-out 0ms;
    }
    .expansion .open-close-icon .fa-chevron-down{
        opacity: 0;
        transform:rotate(-90deg);
        transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
    }
    .expansion input[class^="tab"]:checked ~ .open-close-icon .fa-chevron-down{
        opacity: 0;
        transform: rotate(0deg);
        transition: opacity 50ms linear 0ms, transform 150ms ease-in-out 0ms;
    }




    .trigger_auto{
        width: 270px;
    }
    .trigger_auto span {
        width: 270px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        background: #ffa409;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }


    .newsletter span{
        width: 200px;
        font-weight: bold;
        letter-spacing: 0px;
        font-size: 16px;
        position: relative;
        text-transform: none;
        color: #000000;
        display: block;
        min-width: 0px;
        height: 50px;
        padding: 0 18px;
        z-index: 1;
        cursor: pointer;
        border: 2px solid #000000;
        border-radius: 10px;
        transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-content: center;
    }
    .newsletter:hover span {
        //min-width: 220px;
        border-radius: 10px;
        border: none;
        transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
        color: #000000;
        background: #ffa409;
    }


    input[type="email"]{
        background: rgba(255, 255, 255, 0.1);
        border: none;
        font-size: 16px;
        height: auto;
        margin: 0;
        outline: 0;
        padding: 15px;
        width: 300px;
        background-color: rgba(115, 115, 115, 0.58);
        color: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03) inset;
        margin-bottom: 30px;
    }
    input[type="email"]::placeholder{
        color: #fff;
        font-size: 20px;
    }



.trigger {
  width: 240px;
}

.trigger span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}

.trigger:hover ul.devis a {
  opacity: 1;
}





.trigger-simulation {
  width: 240px;
}

.trigger-simulation span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5B94BC;
  color: #000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger-simulation:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
}

.trigger-simulation:hover ul.devis a {
  opacity: 1;
}


    .paralax-cover-image {
        background-image: url('../assets/img/apropos/a-propos.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 230px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 40px;
    }


    .paralax-cover-image_mobile {
        background-image: url('../assets/img/apropos/a_propos_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        //padding: 20px;
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        // background-attachment: fixed;
        background-position: 100% 40px;
    }


    .hero {
        position: relative;
        background-size: cover;
        background-position: center center;
        height: 680px;
        min-height: 320px;
        max-height: 100%;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
        -ms-flex-pack: center;
        padding: 20px;
    }
    .hero .content_home {
        position: relative;
        min-height: 280px;
        width: 100%;
        margin-left: 8.5%;
        z-index: 2;
        /*//background: red;*/
    }
    .hero .content_home p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        width: 100%;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }


 
 
</style>
